/** @jsxImportSource @emotion/react */

import { Flex } from '../../components/layout/Flex'
import { Layout } from '../../components/layout/Layout'
import { PageContent } from '../../components/layout/PageContent'

import { HeadingNew } from '../../components/HeadingNew'
import { colors } from '../../styles/theme'
import {
  AdId,
  AdSize,
  RevIqAdComponent,
} from '../../components/reviq/RevIqAdComponent'
import { useDetectAdBlock } from '../../components/campaign/useDetectAdBlock'
import { useState } from 'react'
import { ChallengeNavItem } from '../Challenge/ChallengeGroupPage'
import { TextNew } from '../../components/TextNew'

export const AdTestPage = () => {
  const adblockDetected = useDetectAdBlock({ skip: false })

  const [adType, setAdType] = useState<
    'rectangle' | 'largeRectangle' | 'video'
  >('rectangle')

  const [metaInfo, setMetaInfo] = useState<string>(
    `size: ${AdSize.MEDIUM_RECTANGLE} | data-ad=${AdId.rightRail1} | adblockDetected: ${adblockDetected}`
  )

  const textColor = colors.white

  return (
    <Layout backgroundColor={colors.green600} hideNavbar>
      <Flex column grow>
        <PageContent gap={'huge'}>
          <HeadingNew color={colors.white} level={1}>
            {'Ad Test'}
          </HeadingNew>

          <Flex wrap gap={'medium'}>
            <ChallengeNavItem
              title="Rectangle"
              onClick={() => {
                setAdType('rectangle')
                setMetaInfo(
                  `size: ${AdSize.MEDIUM_RECTANGLE} | data-ad=${AdId.rightRail1} | adblockDetected: ${adblockDetected}`
                )
              }}
              selected={adType === 'rectangle'}
              textColor={textColor}
            />
            <ChallengeNavItem
              title="Large Rectangle"
              onClick={() => {
                setAdType('largeRectangle')
                setMetaInfo(
                  `size: ${AdSize.LARGE_RECTANGLE} | data-ad=${AdId.rightRail2} | adblockDetected: ${adblockDetected}`
                )
              }}
              selected={adType === 'largeRectangle'}
              textColor={textColor}
            />
            <ChallengeNavItem
              title="Video"
              onClick={() => {
                setAdType('video')
                setMetaInfo(
                  `size: ${AdSize.LARGE_RECTANGLE} | data-ad=${AdId.videoTop} | adblockDetected: ${adblockDetected}`
                )
              }}
              selected={adType === 'video'}
              textColor={textColor}
            />
          </Flex>

          <TextNew color="white" size={'small'} italic>
            {metaInfo}
          </TextNew>

          {adType === 'rectangle' && (
            <RevIqAdComponent
              adSize={AdSize.MEDIUM_RECTANGLE}
              adId={AdId.rightRail1}
              adblockDetected={adblockDetected}
            />
          )}

          {adType === 'largeRectangle' && (
            <RevIqAdComponent
              adSize={AdSize.LARGE_RECTANGLE}
              adId={AdId.rightRail2}
              adblockDetected={adblockDetected}
            />
          )}

          {adType === 'video' && (
            <RevIqAdComponent
              adSize={AdSize.LARGE_RECTANGLE}
              adId={AdId.videoTop}
              adblockDetected={adblockDetected}
            />
          )}
        </PageContent>
      </Flex>
    </Layout>
  )
}
